import { formatPrice } from 'lib/utils'

const BookingInvoiceList = ({ bookingData, t }) => {
  if (!bookingData?.bookingInvoice?.length) return null

  return (
    <div className="mt-4 w-full">
      <div className="mb-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h4 className="text-[11px] font-bold uppercase tracking-wider text-slate-700">Booking Invoices</h4>
        <span className="inline-flex w-fit items-center rounded-full border border-slate-200/90 bg-slate-900/[0.03] px-3 py-1 text-xs font-bold uppercase tracking-wider text-black">
          {bookingData.bookingInvoice.length} {bookingData.bookingInvoice.length === 1 ? 'Invoice' : 'Invoices'}
        </span>
      </div>

      <div className="grid gap-3">
        {bookingData.bookingInvoice.map((invoice, index) => (
          <div key={index} className="overflow-hidden rounded-xl border border-slate-200/80 bg-white">
            <div className="border-b border-slate-100 bg-slate-50/60 px-4 py-2">
              <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-black">Invoice #{index + 1}</span>
            </div>
            <div className="space-y-2 px-4 py-3 text-sm text-slate-800">
              <div>
                <span className="font-medium text-black">Invoice Status:</span>{' '}
                <span
                  className={`font-semibold capitalize ${
                    invoice?.invoiceStatus === 'paid' ? 'text-green-700' : invoice?.invoiceStatus === 'pending' ? 'text-yellow-700' : 'text-red-700'
                  }`}
                >
                  {invoice?.invoiceStatus || 'N/A'}
                </span>
              </div>

              <div>
                <span className="font-medium text-black">Invoice Payment Status:</span>{' '}
                <span
                  className={`font-semibold capitalize ${
                    invoice?.invoicePaymentStatus === 'paid' ? 'text-green-700' : invoice?.invoicePaymentStatus === 'unpaid' ? 'text-red-700' : 'text-yellow-700'
                  }`}
                >
                  {invoice?.invoicePaymentStatus || 'N/A'}
                </span>
              </div>

              {invoice?.payableAmount && (
                <div>
                  <span className="font-medium text-black">Amount:</span>{' '}
                  <span className="font-semibold text-slate-900 tabular-nums">
                    {formatPrice(invoice.payableAmount, true)} {t('common.omr')}
                  </span>
                </div>
              )}

              {invoice?.reason && (
                <div>
                  <span className="font-medium text-black">Reason:</span> <span className="text-slate-800">{invoice.reason}</span>
                </div>
              )}
            </div>

            <div className="flex justify-end border-t border-slate-100 px-4 py-2.5">
              <button
                type="button"
                onClick={() => {
                  window.location.href = `/booking-invoice/${invoice?._id}`
                }}
                className="inline-flex items-center gap-2 rounded-lg bg-blue-50 px-3 py-1.5 text-xs font-semibold text-blue-700 transition hover:bg-blue-100"
              >
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default BookingInvoiceList
